import { css } from '@emotion/react';

import { SCROLL_DOWN, SCROLL_UP } from '../../const';
import useTheme from '../../hooks/useTheme';
import publicPath from '../../utils/publicPath';

export default () => {
  const {
    colors,
    breakpoints,
    screenSizes,
    spacing,
    typography,
    fluidTypeScale,
  } = useTheme();

  const fixedScrollStyles = (
    divAnimation,
    isMobile,
    isSmallMobile,
    includeBoxShadow = false
  ) => css`
  ${divAnimation === false &&
    css`
    ${includeBoxShadow &&
      css`
      box-shadow: 0px 5px 10px 0px rgba(0, 0, 0, 0.05);
    `}
    opacity: 75%;
    ${includeBoxShadow &&
      css`
      margin-top: calc(100% - 97%) !important;
    `}
    position: fixed;
  `}

  ${divAnimation === true &&
    css`
    position: fixed;
    ${includeBoxShadow &&
      css`
      margin-top: calc(100% - 97%) !important;
    `}
  `}

  ${isMobile &&
    css`
    margin-top: calc(100% - 98%) !important;
  `}

  ${isSmallMobile &&
    css`
    margin-top: 0 !important;
  `}
`;

  const shouldApplyDesktopStyles = (
    scrollDirection,
    direction,
    position,
    isDesktop
  ) =>
    scrollDirection === direction &&
    (isDesktop ? position > 370 : position > 636);

  const shouldApplyIpadStyles = (
    scrollDirection,
    direction,
    position,
    isIpad
  ) =>
    scrollDirection === direction &&
    (isIpad ? position > 370 : position > 540);

  return {
    base: css`
      height: 412px;
      max-height: 50.625rem;
      ${breakpoints.m} {
        height: 611px;
      }
    `,
    skipLinkTrap: css`
      position: absolute,
      width: 1,
      height: 1,
      overflow: hidden,
      `,
    quickLinks: (
      divAnimation,
      scrollDirection,
      position,
      isDesktop,
      isIpad,
      isMobile,
      isSmallMobile
    ) => css`
      max-width: 311px !important;
      position: absolute;
      padding-left: 0px !important;
      padding-top: 0px !important;
      cursor: pointer;
      margin-top: calc(100% - -76%);
      margin-left: calc(100% - 92%) !important;
      border-radius: 8px;
      background-image: none !important;
      z-index: 100;
      position: absolute;

      ${isMobile &&
      css`
          margin-top: 700px;
          margin-left: calc(100% - 89%) !important;
        `
      }

      ${isSmallMobile &&
      css`
          margin-top: 667px !important;
        `
      }

      ${isDesktop &&
      css`
          margin-top: calc(100% - 64%) !important;
          margin-left: calc(100% - 35%) !important;
        `
      }

      ${isIpad &&
      css`
          margin-left: calc(100% - 40%) !important;
          margin-top: calc(100% - 47%) !important;
        `
      }

      ${shouldApplyDesktopStyles(
        scrollDirection,
        SCROLL_UP,
        position,
        isDesktop
      ) &&
      css`
        margin-top: calc(100% - 88%) !important;
        
      ${fixedScrollStyles(
        divAnimation,
        isMobile,
        isSmallMobile,
        true
      )}

      @media screen and (max-width: 380px) {
            margin-top: 0 !important;
          }
        `
      }
      ${shouldApplyIpadStyles(
        scrollDirection,
        SCROLL_UP,
        position,
        isIpad
      ) &&
      css`
        margin-top: calc(100% - 88%) !important;

      ${fixedScrollStyles(
        divAnimation,
        false,
        false,
        true
      )}
        `
      }
        ${shouldApplyDesktopStyles(
        scrollDirection,
        SCROLL_DOWN,
        position,
        isDesktop
      ) &&
      css`
        margin-top: calc(100% - 88%) !important;

      ${fixedScrollStyles(
        divAnimation,
        isMobile,
        isSmallMobile
      )}
        `
      }
      ${shouldApplyIpadStyles(
        scrollDirection,
        SCROLL_DOWN,
        position,
        isIpad
      ) &&
      css`
        margin-top: calc(100% - 88%) !important;

      ${fixedScrollStyles(
        divAnimation,
        false,
        false
      )}
      `
    }
      }

       ${breakpoints.m} {
        margin-left: calc(100% - 36%) !important;
        position: absolute;
        background-color: white;
        background-image: none !important;
        margin-top: 392px !important;
        
      }
    `,
    quick: closeani => css`
      max-width: 311px !important;
      height: 0px;
      background-color: ${colors.white};
      border: 1px ${colors.lightGrey} solid;
      border-radius: 0 0 8px 8px !important;
      display: none;
      opacity: 0;
      border-top: 0;

      ${breakpoints.xl} {
        border-radius: 0 0 8px 8px !important;
      }

      ${closeani === true &&
      css`
        height: 194px;
        animation-name: opacitytest;
        animation-duration: 1s;
        margin: auto;
        display: grid;
        animation-fill-mode: forwards;
        -webkit-animation-fill-mode: forwards;

        @keyframes opacitytest {
          50% {
            transition-property: opacity;
            transition: 0.5s;
            transition-timing-function: ease-in-out;

            opacity: 0.5;
          }
          100% {
            opacity: 1;
          }
        }
      `}

      ${closeani === false &&
      css`
        transition-property: height;
        transition-duration: 0.1s;
        transition-timing-function: ease-in-out;
      `}
    `,
    sectionStyle: css`
      font-size: 18px;
      color: ${colors.navy};
    `,
    closeIcon: closeani => css`
      cursor: pointer;
      margin: auto;

      svg {
        color: red;
        width: 20px;
        height: 3px;
        margin: auto;
        position: relative;
        z-index: 0;
        bottom: 0;
        left: 0;
        right: 0;
        overflow-y: hidden;

        ${closeani === true &&
        css`
          animation-name: closeicon;
          animation-duration: 0.7s;
          margin: auto;

          @keyframes closeicon {
            50% {
              transition-property: width;
              transition: 0.5s;
              transition-timing-function: ease-in-out;

              width: 5px;
            }
            100% {
              width: 20px;
            }
          }
        `}
      }
    `,

    listData: css`
      align-items: center;
      display: grid;
      grid-template-columns: 6% auto;
      grid-template-rows: 95% 5%;
      font-size: 18px;
      color: ${colors.navy};
      width: 263px;
      padding-left: 9px;
      height: 48px;

      &:hover {
        border: 0px;
        background-color: ${colors.lightGrey};
        border-radius: 10px;
      }
    `,
    quickAnimate: css`
      padding-left: 23px;
    `,
    redlineSVG: css`
      display: grid;
      grid-template-columns: 7% auto;
    `,
    svgStyle: css`
      margin-top: 5px;
    `,
    onThisPage: divAnimation => css`
      font-size: 20px;
      font-weight: 700;
      color: ${colors.navy};
      border: 1px ${colors.lightGrey} solid;
      border-bottom: 0 grey solid;
      background-color: ${colors.lightGrey};
      display: grid;
      grid-template-columns: 65% 35%;
      grid-template-rows: 99% 1%;
      padding-left: 25px;
      height: 60px;
      border-radius: 8px !important;
      width: 311px;

      ${divAnimation === true &&
      css`
        border-radius: 8px 8px 0 0 !important;
        background-color: ${colors.white};
      `}
    `,
    pageHeading: css`
      margin-bottom: 10px;
      padding-top: 18px;
    `,
    hero: css`
      position: relative;
      > div {
        margin: auto;
        width: 100%;
        padding: calc(100vh - 75vh) 0 0 2rem;
        background-image: linear-gradient(
            to bottom,
            rgba(0, 0, 0, 0) 0%,
            rgba(1, 30, 65) 75%,
            rgba(1, 30, 65) 100%
          ),
          url('/images/desktop/home/homeback1.webp');
        background-repeat: no-repeat;

        ${breakpoints.m} {
          background-image: none;
        }
      }

      @media (min-width: 992px) {
        background-position: 0 0;

        > div {
          max-width: ${screenSizes.l};
          align-self: center;
          padding-top: 80px;
          width: 100%;
          margin: auto;
        }
      }

      @media (min-width: 768px) {
        grid-template-rows: 1fr;
        background-position: 64% 0;

        > div {
          max-width: 67%;
          align-self: center;
          padding-top: 80px;
          width: 100%;
          margin: auto;
        }
      }

      @media (min-device-width: 768px) and (max-device-width: 992px) {
        padding: 0 !important;
      }
    `,
    footballTypeSection: css`
      position: relative;
      background-color: ${colors.navy};
      z-index: 1;
      margin-top: -1px;
    `,
    everyOneGameSection: css`
      position: relative;
      display: grid;
      background: url(${publicPath('/images/mobile/home/fa-initiative-bg.svg')})
        0 0 no-repeat;
      background-size: cover;
      width: 100%;

      ${breakpoints.l} {
        background: url(${publicPath(
            '/images/desktop/home/fa-initiatives-bg.svg'
          )})
          0 0 no-repeat;
        background-size: cover;
        margin-top: ${spacing.m};
      }
    `,
    everyOneGameContent: css`
      position: relative;
      display: grid;
      width: 100%;
      ${breakpoints.m} {
        grid-template-rows: 35% 65%;
      }

      ${breakpoints.l} {
        height: 47.5rem;
        grid-template-rows: 50% 50%;
      }
    `,
    footballTypeContainer: css`
      display: grid;
      grid-auto-rows: 14.625rem;
      grid-gap: ${spacing.s};
      padding: ${spacing.l} 0 1.5rem;
      grid-template-columns: 1fr;
      margin: auto;
      width: 90vw;
      justify-items: center;
      max-width: ${screenSizes.m};
      grid-template-rows: 42% 50%;

      ${breakpoints.m} {
        padding-bottom: 2.5rem;
        grid-template-columns: 1fr 1fr;
        grid-template-rows: unset;
        grid-gap: ${spacing.m};
        grid-auto-rows: 20.5rem;
        justify-items: initial;
        max-width: ${screenSizes.xl};
      }

      ${breakpoints.xl} {
        padding-bottom: 1.5rem;
        grid-auto-rows: 27.5rem;
        grid-gap: ${spacing.l};
      }
    `,
    initiativeContainer: count => css`
      display: grid;
      max-width: 500px;
      margin: auto;

      ${breakpoints.m} {
        max-width: ${screenSizes.xl};
        grid-template-columns: repeat(${count}, 1fr);
        grid-auto-rows: minmax(12.5rem, auto);
        align-content: center;
      }
    `,
    quickLinkSection: css`
      position: relative;
      background: url(${publicPath('/images/mobile/home/quick-link-bg.svg')}) 0
        0 no-repeat;
      background-size: contain;
      margin-top: -1px;

      ${breakpoints.l} {
        background: url(${publicPath('/images/desktop/home/quick-link-bg.svg')})
          0 0 no-repeat;
        background-size: cover;

        &::before {
          content: '';
          background: url(/images/desktop/home/play-watermark.svg) bottom right
            no-repeat
          height: 86%;
          position: absolute;
          width: 25%;
          right: 0;
          top: -16rem;
          bottom: 0;
          z-index: 2;
          pointer-events: none;
        }
      }
    `,
    quickLinkContent: css`
      display: grid;
      grid-template-rows: 26% auto;
      max-width: 500px;
      margin: auto;
      width: 90vw;
      height: 60rem;

      ${breakpoints.m} {
        grid-template-rows: 32% auto;
      }

      ${breakpoints.l} {
        grid-template-rows: 40% 50%;
        max-width: ${screenSizes.xl};
        margin: auto;
        height: 50rem;
      }
    `,
    waysToPlayContainer: css`
      background-color: ${colors.white};
      display: inline-block;
      width: 100%;
      padding-top: 50px;
      padding-bottom: 50px;
    `,
    waysToPlayinnerContainer: css`
      width: 100%;
      margin: auto;
      max-width: 1196px;

      ${breakpoints.m} {
        width: 95%;
        margin: auto;
        max-width: 1196px;
      }

      ${breakpoints.l} {
        width: 67%;
        margin: auto;
        max-width: 1196px;
      }
    `,
    waysToPlayCards: css`
    width: 100%;
    display: flex;
    column-gap: 10px;
    padding: 0 10px;
    overflow-x: auto;
    scroll-snap-type: x mandatory;
    scroll-behavior: smooth;

    .WaysToPlay-container {
      display: grid;
      overflow-x: auto;
      scroll-snap-type: x mandatory;
      scroll-behavior: smooth;
      grid-template-columns: repeat(3, 1fr);
      width:100%;
      margin-left: 20px;
    }
      
      @media screen and (min-width: 769px){
        width: fit-content;
        display: grid;
        grid-template-columns: repeat(3, 1fr);
        grid-template-rows: auto;
        column-gap: 10px;
        row-gap: 2.4rem;

      ${breakpoints.l} {
        width: fit-content;
        display: grid;
        grid-template-columns: repeat(3, 1fr);
        grid-template-rows: auto;
        column-gap: 10px;
        row-gap: 2.4rem;
      }

    `,
    ways: MQtoHideQuickLinks => css`
      display: flex;
      gap: 20px;
      align-items: center;
      margin-bottom: 1.5rem;

      // @media screen and (max-width: ${screenSizes.m}) {
      //   padding-top: 140px;
      // }

      ${MQtoHideQuickLinks &&
      css`
        padding-top: 50px;
      `}
    `,
    waysToPlayHead: css`
      font-weight: 700;
      color: ${colors.navy};
      font-style: normal !important;
      font-size: 1.944rem !important;
      ${breakpoints.m} {
        font-size: 2.221rem !important;
      }
    `,
    clubSessionalHeader: css`
      color: ${colors.white};
    `,

    clubVSTeamContainer: css`
      background-color: ${colors.navy};
      display: inline-block;
      width: 100%;
      padding-top: 50px;
    `,
    clubVSTeamInnerContainer: css`
      width: 100%;
      margin: auto;
      max-width: 1196px;
      background-color: ${colors.navy};

      ${breakpoints.m} {
        width: 95%;
        margin: auto;
        max-width: 1196px;
      }

      ${breakpoints.l} {
        width: 65%;
        margin: auto;
        max-width: 1196px;
      }
    `,
    clubVSTeambelowContainer: css`
      background: url(${publicPath(
          '/images/desktop/home/graphic-divider-desktop.svg'
        )})
        center bottom no-repeat;
      background-size: contain;
      width: 100%;
      height: 100%;
    `,
    clubVsFootballCards: css`
      width: fit-content;
      display: grid;
      grid-template-rows: auto;
      padding: 0px;
      background-color: ${colors.navy};

      ${breakpoints.m} {
        width: fit-content;
        display: grid;
        grid-template-columns: repeat(2, 1fr);
        grid-template-rows: auto;
        column-gap: 20px;
      }

      ${breakpoints.l} {
        width: fit-content;
        display: grid;
        grid-template-columns: repeat(2, 1fr);
        grid-template-rows: auto;
        column-gap: 20px;
        row-gap: 2.4rem;
      }
    `,
    cVSf: css`
      font-size: ${fluidTypeScale.font31_35};
      display: flex;
      gap: 20px;
      font-weight: 700;
      color: ${colors.white};
      align-items: center;
      margin-bottom: 15px;
    `,
    cVSfborder: css`
      width: 10px;
      height: 20px;
      border: 21px 0px 0px 0px;
      border: 7px solid ${colors.red_CB0A00};
    `,
    border: css`
      width: 10px;
      height: 20px;
      border: 21px 0px 0px 0px;
      border: 7px solid ${colors.blue_214C99};
    `,
    initiativeHeading: css`
      ${typography.headings[5].mobile};
      color: ${colors.white};
      font-style: italic;
      text-transform: capitalize;
      margin-top: ${spacing.l};
      position: relative;
      width: 100%;
      display: grid;
      padding: 20px;
      align-content: end;

      div {
        text-align: center;
      }

      &::before {
        content: '';
        position: absolute;
        height: 100%;
        width: 100%;

        bottom: 0;
        align-content: end;

        ${breakpoints.m} {
          background: url(${publicPath(
              '/images/desktop/home/every-one-watermark.svg'
            )})
            center bottom no-repeat;
          background-size: contain;
          bottom: -2rem;
        }
      }

      ${breakpoints.l} {
        font-size: 3.875rem;
        line-height: 2.5rem;
        margin-top: ${spacing.xxl};
        padding: 0;
      }
    `,
    infoSection: css`
      display: grid;
      padding-bottom: 1.5rem;
      align-content: end;
      label {
        display: block;
      }

      ${breakpoints.l} {
        padding-bottom: ${spacing.m};
      }
    `,
    waysToPlayMobileTabContainer: css`
      text-align: center;
      font-weight: 700;
      padding: 0;
      background: ${colors.white};
      z-index: 1;
      text-align: left;
      padding-bottom: 50px;
    `,
    tabBorder: css`
      border-bottom: 1px solid ${colors.darkGrey};
    `,
    tabsName: isActive => css`
      display: inline-block;
      background: ${colors.white};
      position: relative;
      border-bottom: 1px solid ${colors.darkGrey};
      width: 33%;
      &::before {
        opacity: 0;
        transition: 0.3s ease;
      }
      &::after {
        opacity: 0;
        transition: 0.3s ease;
      }
      .labelWays {
        height: 100%;
        width: max-content;
        padding: 0.6em 0;
        border-bottom: ${isActive === true ? '2px solid red' : 'none'};
      }
    `,
    FAProgrammesContainer: css`
      background-color: ${colors.white};
      display: inline-block;
      width: 100%;
      padding-top: 50px;
    `,
    FAProgrammesinnerContainer: css`
      width: 100%;
      margin: auto;
      max-width: 1196px;

      ${breakpoints.m} {
        width: 90%;
        margin: auto;
        max-width: 1196px;
      }

      ${breakpoints.l} {
        width: 65%;
        margin: auto;
        max-width: 100%;
        margin-left: 18%;
      }
    `,
    WaysinnerContainer: css`
      width: 100%;
      margin: auto;
      max-width: 1196px;

      ${breakpoints.m} {
        width: 90%;
        margin: auto;
        max-width: 1196px;
      }

      ${breakpoints.l} {
        width: 65%;
        margin: auto;
        max-width: 100%;
        margin-left: 18%;
      }
    `,
    FAprogrammes: css`
      font-size: ${fluidTypeScale.font31_35};
      display: flex;
      gap: 20px;
      font-weight: 700;
      line-height: 40px;
      color: ${colors.navy};
      align-items: center;
      margin-bottom: 30px;
    `,
    navTab: css`
      display: flex;
      width: 93%;
      gap: 70px;
      margin-left: 20px;
      cursor: pointer;
      white-space: nowrap;
      overflow: auto;
      padding-top: 10px;

      &::-webkit-scrollbar {
        display: none;
      }

      &::webkit-scrollbar-thumb {
        border-radius: 4px;
      }
    `,
    navigation: isScrolledFa => css`
      display: flex;
      width: 90%;
      grid-gap: 70px;
      margin-left: 20px;
      cursor: pointer;
      white-space: nowrap;
      overflow: auto;

      &::-webkit-scrollbar {
        display: none;
      }

      &::webkit-scrollbar-thumb {
        border-radius: 4px;
      }

      /* general media query for iPhone 12 and below */
      @media only screen and (max-width: 390px) {
        grid-gap: 20px;
      }

      /* iPhone 11, XR (414px x 896px) */
      @media only screen and (max-width: 414px) and (max-height: 896px) {
        grid-gap: 40px;
      }

      @media screen and (min-width: ${screenSizes.xl}) {
        ${isScrolledFa === true &&
        css`
          -webkit-mask-image: linear-gradient(
            to left,
            white,
            white 650px,
            transparent
          );
        `}
      }

      ${breakpoints.l} {
        display: flex;
        margin-left: 2px;
        cursor: pointer;
        white-space: nowrap;
      }
    `,
    highlightborder: css`
      border: 1px 0px 0px 0px;
      border: 1px solid ${colors.darkGrey};
      margin-left: 20px;
      ${breakpoints.m} {
        width: 85%;
      }

      ${breakpoints.l} {
        margin-left: 1px;
      }
    `,
    FAProgrammesCards: css`
      width: 100%;
      display: grid;
      grid-template-rows: auto;
      row-gap: 2.4rem;
      padding-top: 20px;
      padding-left: 20px;
      align-items: center;

      .FAProgrammes-container {
        display: flex;
        width: 100%;
        overflow-x: auto;
        scroll-snap-type: x mandatory;
        scroll-behavior: smooth;
        -webkit-overflow-scrolling: touch;

        ::-webkit-scrollbar {
          display: none;
        }

        > * {
          flex: 0 0 auto;
          width: 291px;
          scroll-snap-align: start;
          margin-right: 10px;
        }
      }
      ${breakpoints.m} {
        .FAProgrammes-container {
          > * {
            width: 306px;
          }
        }
      }

      ${breakpoints.m} {
        .FAProgrammes-container {
          display: flex;
          width: 100%;
          overflow-x: auto;
          scroll-snap-type: x mandatory;
          scroll-behavior: smooth;
          -webkit-overflow-scrolling: touch;

          > * {
            flex: 0 0 auto;
            width: 306px;
            scroll-snap-align: start;
          }
        }
      }

      ${breakpoints.l} {
        .FAProgrammes-container {
          display: flex;
          width: 121%;
          margin-left: -2%;
        }
      }

      .backbutton {
        z-index: 5;
        position: absolute;
        left: 0%;
        transform: translateX(50%) translateY(-140px);
        cursor: pointer;
        margin-left: -2%;
        display: none;
        &:focus-visible {
        outline: 2px solid ${colors.skip_yellow};
          img{
            border: 2px solid ${colors.border_black};
          }
        }
      }
      @media (min-width: 768px) and (max-width: 992px) {
        .backbutton {
          margin-left: -3.5%;
          display: none;
        }
      }
      @media (min-width: 993px) and (max-width: 1024px) {
        .backbutton {
          margin-left: -2.5%;
          display: none;
        }
      }
      @media (min-width: 1025px) {
        .backbutton {
          margin-left: -2%;
          display: block;
        }
      }

      .frontbutton {
        z-index: 5;
        position: absolute;
        right: 0%;
        transform: translateX(50%) translateY(-140px);
        cursor: pointer;
        margin-right: 3%;
        display: none;
        &:focus-visible {
        outline: 2px solid ${colors.skip_yellow};
          img{
            border: 2px solid ${colors.border_black};
          }
        }
      }

      @media (min-width: 768px) {
        .frontbutton {
          display: block;
        }
      }
      @media (min-width: ${breakpoints.m}) and (max-width: ${breakpoints.l}) {
        .FAProgrammes-container {
          display: grid;
          overflow-x: auto;
          scroll-snap-type: x mandatory;
          scroll-behavior: smooth;
          -webkit-overflow-scrolling: touch;
          > * {
            flex: 0 0 auto;
            width: 80%;
            scroll-snap-align: start;
          }
        }

        .backbutton,
        .frontbutton {
          display: block;
        }
      }
      @media (min-width: 768px) and (max-width: 1024px) {
        .frontbutton {
          display: none;
        }
      }
    `,
    Dots: css`
      display: flex;
      align-items: center;
      justify-content: center;
      margintop: 20px;
      transform: translateY(-20px);
      @media (max-width: 767px) {
        display: none;
      }
    `,
    dotStyles: ({ isActive }) => css`
      width: 10px;
      height: 10px;
      border-radius: 50%;
      background-color: ${isActive ? `${colors.red}` : `${colors.darkGrey}`};
      margin: 0 10px;
      cursor: pointer;
      margin-bottom: 40px;
      &:hover {
        background-color: ${colors.blue};
      }
      &:focus-visible {
        outline: 2px solid ${colors.skip_yellow};
        border: 1px solid ${colors.border_black};
      }  
    `,
    active: css`
      border-bottom: 3px solid ${colors.red};
      color: ${colors.black};
      align-self: center;
    `,
    disabilityFootballDivider: css`
      width: 100%;
    `,
    DisabilityFootballContainer: marginRemoved => css`
      display: inline-block;
      width: 100%;
      padding-top: 50px;
      ${breakpoints.m} {
        ${marginRemoved === true &&
        css`
          width: 89%;
        `}
      }

      ${breakpoints.l} {
        ${marginRemoved === true &&
        css`
          width: 80%;
        `}
      }
    `,
    DisabilityFootballinnerContainer: marginRemoved => css`
      width: 100%;
      margin: auto;
      max-width: 1196px;

      ${breakpoints.m} {
        width: 90%;
        margin: auto;
        max-width: 1196px;
      }

      ${breakpoints.l} {
        width: 65%;
        margin: auto;
        max-width: 100%;
        margin-left: 18%;
        ${marginRemoved === true &&
        css`
          margin: 0px;
          width: 100%;
        `}
      }
    `,
    DisabilityFootballprogrammes: marginRemoved => css`
      font-size: ${fluidTypeScale.font32_32};
      display: flex;
      gap: 20px;
      font-weight: 700;
      line-height: 36px;
      color: ${colors.navy};
      align-items: center;
      margin-bottom: 30px;
      ${marginRemoved === true &&
      css`
        margin-left: 18%;
        width: 100%;
      `}
      ${breakpoints.l} {
        ${marginRemoved === true &&
        css`
          width: 80%;
        `}
      }
    `,
    disablitynavigation: (isScrolled, marginRemoved) => css`
      display: flex;
      grid-gap: 48px;
      margin-left: 20px;
      overflow-x: auto;
      opacity: 0px;
      cursor: pointer;
      white-space: nowrap;

      &::-webkit-scrollbar {
        display: none;
      }

      &::webkit-scrollbar-thumb {
        border-radius: 4px;
      }

      @media screen and (min-width: ${screenSizes.xl}) {
        ${isScrolled === true &&
        css`
          -webkit-mask-image: linear-gradient(
            to left,
            white,
            white 950px,
            transparent
          );
        `}
      }
      ${breakpoints.l} {
        display: flex;
        width: 121%;
        margin-left: 2px;
        cursor: pointer;
        white-space: nowrap;
        ${marginRemoved === true &&
        css`
          margin-left: 18%;
          width: 100%;
        `}
      }
    `,
    waysHeader: activatedId => css`
      font-size: ${fluidTypeScale.font15_16};
      font-weight: 700;
      line-height: 20px;
      letter-spacing: -0.01em;
      text-align: center;
      color: ${colors.darkGrey};
      padding-bottom: 10px;
      ${activatedId === true &&
      css`
        border-bottom: 3px solid ${colors.red};
        color: ${colors.black};
        align-self: center;
      `}

      ${breakpoints.m} {
        font-weight: 700;
        line-height: 20px;
        letter-spacing: 0.08em;
        text-align: left;
      }
    `,
    faprogrammeHeader: activatedId => css`
      font-size: ${fluidTypeScale.font15_16};
      font-weight: 700;
      line-height: 24px;
      letter-spacing: 0.08em;
      text-align: center;
      color: ${colors.darkGrey};
      padding-bottom: 10px;
      ${activatedId === true &&
      css`
        border-bottom: 3px solid ${colors.red};
        color: ${colors.black};
        align-self: center;
      `}
      &:hover {
        cursor: pointer;
        font-weight: bold;
        color: ${colors.black};
      }
      &:active {
        font-weight: bold;
        color: ${colors.black};
      }
      &:focus-visible {
        outline: none;
        background-color: ${colors.skip_yellow};
        color: ${colors.border_black};
        border-bottom: 3px solid ${colors.border_black};
      }

      ${breakpoints.m} {
        font-weight: 700;
        line-height: 20px;
        letter-spacing: 0.08em;
        text-align: left;
      }
    `,
    header: css`
      font-size: ${fluidTypeScale.font15_15};
      font-weight: 700;
      line-height: 24px;
      letter-spacing: 0.08em;
      text-align: center;
      color: ${colors.darkGrey};
      padding-bottom: 10px;
      &:hover {
        cursor: pointer;
        font-weight: bold;
        color: ${colors.black};
      }
      &:active {
        font-weight: bold;
        color: ${colors.black};
      }
      &:focus-visible {
        outline: none;
        background-color: ${colors.skip_yellow};
        color: ${colors.border_black};
        border-bottom: 3px solid ${colors.border_black};
      }

      ${breakpoints.m} {
        font-weight: 700;
        line-height: 20px;
        letter-spacing: 0.08em;
        text-align: left;
      }
    `,
    navigationborder: marginRemoved => css`
      border: 1px solid #5b6885;
      margin-left: 20px;

      ${breakpoints.l} {
        width: 121%;
        margin-left: 1px;
        ${marginRemoved === true &&
        css`
          margin-left: 18%;
          width: 100%;
        `}
      }
    `,
    disabilityHeader: css`
      font-size: ${fluidTypeScale.font15_15};
      font-weight: 700;
      line-height: 20px;
      letter-spacing: 0.08em;
      text-align: center;
      scroll-snap-align: center;
      align-self: center;
      color: ${colors.darkGrey};
      padding-bottom: 10px;

      ${breakpoints.m} {
        width: 100%;
        font-weight: 700;
        line-height: 20px;
        letter-spacing: 0.08em;
        text-align: left;
      }
    `,
    DisabilityFootballCards: css`
      width: 100%;
      display: grid;
      grid-template-rows: auto;
      padding-top: 20px;
      padding-left: 20px;
      margin-top: 20px;
      align-items: center;

      .DisabilityFootball-container {
        display: flex;
        width: 100%;
        overflow-x: auto;
        scroll-snap-type: x mandatory;
        scroll-behavior: smooth;
        -webkit-overflow-scrolling: touch;

        /* Hide the scrollbars */
        ::-webkit-scrollbar {
          display: none;
        }

        > * {
          flex: 0 0 auto;
          width: 291px;
          scroll-snap-align: start;
          margin-right: 10px;
        }
      }

      ${breakpoints.m} {
        .DisabilityFootball-container {
          > * {
            width: 306px;
          }
        }
      }

      ${breakpoints.m} {
        .DisabilityFootball-container {
          display: flex;
          width: 100%;
          overflow-x: auto;
          scroll-snap-type: x mandatory;
          scroll-behavior: smooth;
          -webkit-overflow-scrolling: touch;

          > * {
            flex: 0 0 auto;
            width: 306px;
            scroll-snap-align: start;
          }
        }
      }

      ${breakpoints.l} {
        .DisabilityFootball-container {
          display: flex;
          width: 121%;
          margin-left: -2%;
        }
      }

      .disabilitybackbutton {
        z-index: 5;
        position: absolute;
        left: -1%;
        transform: translateX(50%) translateY(-140px);
        cursor: pointer;
        margin-left: -1%;
        display: none;
        &:focus-visible {
        outline: 2px solid ${colors.skip_yellow};
          img{
            border: 2px solid ${colors.border_black};
          }
        }
      }
      @media (min-width: 768px) and (max-width: 992px) {
        .disabilitybackbutton {
          margin-left: -2.5%;
          display: none;
        }
      }
      @media (min-width: 993px) and (max-width: 1024px) {
        .disabilitybackbutton {
          margin-left: -1.5%;
          display: none;
        }
      }
      @media (min-width: 1025px) {
        .disabilitybackbutton {
          margin-left: -1%;
          display: block;
        }
      }

      .frontbutton {
        z-index: 5;
        position: absolute;
        right: 0%;
        transform: translateX(50%) translateY(-140px);
        cursor: pointer;
        margin-right: 3%;
        display: none;
        &:focus-visible {
        outline: 2px solid ${colors.skip_yellow};
          img{
            border: 2px solid ${colors.border_black};
          }
        }
      }

      @media (min-width: 768px) {
        .frontbutton {
          display: block;
        }
      }

      @media (min-width: ${breakpoints.m}) and (max-width: ${breakpoints.l}) {
        .DisabilityFootball-container {
          display: grid;
          overflow-x: auto;
          scroll-snap-type: x mandatory;
          scroll-behavior: smooth;
          -webkit-overflow-scrolling: touch;

          > * {
            flex: 0 0 auto;
            width: 80%;
            scroll-snap-align: start;
          }
        }
        .backbutton,
        .frontbutton {
          display: block;
        }
      }
      @media (min-width: 768px) and (max-width: 1024px) {
        .frontbutton {
          display: none;
        }
      }
    `,
  };
};
